import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { PTBBCarousel } from './prop-types.js';
import useScreenSize from '../../../../hooks/useScreenSize';
import { pushSliderHasChanged as gtmPushSliderHasChanged } from '../../../../utils/gtm';
import BBCarouselDesktopStandard from './BBCarouselDesktop/BBCarouselDesktopStandard';
import BBCarouselDesktopStory from './BBCarouselDesktop/BBCarouselDesktopStory';
import BBCarouselMobile from './BBCarouselMobile';

import styles from './index.module.scss';

const BBCarousel = ({ type, uuid, ...props }) => {
  const [state, setState] = useState({
    isDesktop: null,
    isMobile: null,
    activeSlideIndex: 0,
    transitioning: true,
  });
  const { width } = useScreenSize();

  const onBeforeSlideChange = () => {
    setState((prev) => ({ ...prev, transitioning: true }));
  };

  const onAfterSlideChange = (index) => {
    setState((prev) => ({
      ...prev,
      activeSlideIndex: index,
      transitioning: false,
    }));

    gtmPushSliderHasChanged({
      uuid,
      type: `${type}_carousel`,
      current_item: index,
    });
  };

  if (width >= 768 && !state.isDesktop) {
    setState((prev) => ({
      ...prev,
      isDesktop: true,
      isMobile: false,
      activeSlideIndex: 0,
    }));
  }

  if (width < 768 && !state.isMobile) {
    setState((prev) => ({
      ...prev,
      isDesktop: false,
      isMobile: true,
      activeSlideIndex: 0,
    }));
  }

  useEffect(() => {
    setState((prev) => ({ ...prev, transitioning: false }));
  }, []);

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToScroll: 1,
    beforeChange: onBeforeSlideChange,
    afterChange: onAfterSlideChange,
    navClass: `bb-carousel${type === 'story' ? '-story' : ''}--navigation`,
  };

  const BBCarouselDesktop = type === 'story' ? BBCarouselDesktopStory : BBCarouselDesktopStandard;

  return (
    <>
      {state.isDesktop && (
        <BBCarouselDesktop
          {...props}
          {...state}
          uuid={uuid}
          sliderSettings={sliderSettings}
          bbCarouselStyles={styles}
        />
      )}
      {state.isMobile && (
        <BBCarouselMobile
          {...props}
          {...state}
          uuid={uuid}
          sliderSettings={sliderSettings}
          bbCarouselStyles={styles}
        />
      )}
    </>
  );
};

BBCarousel.propTypes = {
  ...PTBBCarousel,
  type: PropTypes.oneOf(['standard', 'story']).isRequired,
};

export default BBCarousel;
